// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// utils
import get from "../../utils/GetNested";

export const GetGroup = CreateProcess({
	method: "GET",
	name: "GetGroup",
	type: "GROUPS:FETCHONE",

	request: (props) => ({
		url: `/api/v0.1/groups/${props.groupId}/`,
	}),

	success: (response) => {
		const data = fromJS({
			_id: response.data.id,
			name: response.data.name,
			permissions: response.data.admin_permissions,
		});

		return data;
	},
});

export const GetGroups = CreateProcess({
	method: "POST",
	name: "GetGroups",
	type: "GROUPS:FETCHBULK",

	request: (props) => {
		const payload = get(props, ["params", "payload"], props.payload);

		return {
			url: "/micro/v0.1/group-picker/",
			payload,
		};
	},

	success: (response) => response.data,
});

export const DeleteGroup = CreateProcess({
	method: "DELETE",
	name: "DeleteGroup",
	type: "GROUPS:DELETE",

	request: (props) => ({
		url: "/api/delete-department/",
		payload: props.payload,
	}),

	success: (response) => response.data,
});

export const UpdateGroupName = CreateProcess({
	method: "POST",
	name: "UpdateGroupName",
	type: "GROUPS:NAME.UPDATE",

	request: (props) => ({
		url: "/ajax/edit-department/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const AddGroupMembers = CreateProcess({
	method: "POST",
	name: "AddGroupMembers",
	type: "GROUPS:MEMBERS.ADD",

	request: (props) => ({
		url: "/api/department-membership/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const AddGroupAdmins = CreateProcess({
	method: "POST",
	name: "AddGroupAdmins",
	type: "GROUPS:ADMINS.ADD",

	request: (props) => ({
		url: "/ajax/assign-admin-to-department/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const RemoveGroupAdmins = CreateProcess({
	method: "POST",
	name: "RemoveGroupAdmins",
	type: "GROUPS:EMPLOYEES.REMOVE",

	request: (props) => ({
		url: "/api/remove-admin-from-department/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const RemoveGroupMembers = CreateProcess({
	method: "POST",
	name: "RemoveGroupMembers",
	type: "GROUPS:EMPLOYEES.REMOVE",

	request: (props) => ({
		url: "/api/department-membership/",
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});

export const ChangeGroupPermission = CreateProcess({
	method: "POST",
	name: "ChangeGroupPermission",
	type: "GROUPS:PERMISSIONS.UPDATE",

	request: (props) => ({
		url: `/api/groups/${props.groupID}/permissions/`,
		payload: props.payload,
	}),

	success: (response) => fromJS(response.data),
});
